/********************************************************
* Room Select Control
*
* please add description of module here
*
********************************************************/



/**********************************************
 DEPENDENCIES
**********************************************/
var $ = require('jquery');
var utils = require('Utilities/utils');



/**********************************************
 Variable Declarations
**********************************************/
var self = {};
var dd_state = false;
var active_value = null;
var listener = false;
var listener_cb;
var options = {};
var default_text;

// default options
var default_args = {}



/**********************************************
 Private Functions
**********************************************/

// check if in drop down mode or not
var is_dd_mode = function() {
	if(!$('.room-selector__dd-btn').is(':visible')) return true;
	return false;
}


// responde to drop down button click
var dd_btn_clicked = function(e) {
	e.preventDefault();
	e.stopPropagation();

	// if in drop down mode then toggle state with no value update
	if (is_dd_mode) toggle_state();

	// scroll back into proper position on page
	$('html, body').animate({scrollTop: $('.vdm-container').offset().top}, 500);
}


// toggle drop down state
var toggle_state = function() {
	if (dd_state) close_dd();
	else open_dd();
}


// close drop down room selection
var close_dd = function() {
	dd_state = false;
	$('.room-selector__group').removeClass('room-selector__group--active');
}


// open drop down room selection
var open_dd = function() {
	dd_state = true;
	$('.room-selector__group').addClass('room-selector__group--active');
}


// room clicked on
var room_clicked = function(e) {

	// clear selector on any other room
	$('.rooms__room--active').removeClass('rooms__room--active');

	// retrive text and data-value from selected
	var $target = $(e.target);
	$('.room-selector__dd-btn .h5').text( $target.html() );
	active_value = $target.attr('data-value');
	
	// apply selected class
	$target.addClass('rooms__room--active');

	// if in drop down mode close list
	if (is_dd_mode) close_dd();

	// if listener active then fire callback
	if (listener) {
		if (listener_cb) listener_cb(active_value);
	}
}






/**********************************************
 Public Functions
**********************************************/

// launch method
self.init = function(params) {
	default_text = $('.room-selector__dd-btn .h5').html();

	// add listener to drop down button
	$('.room-selector__dd-btn').off().on('click', dd_btn_clicked);

	// add listener to rooms in list
	$('.rooms__room').off().on('click', room_clicked);
}


// clear value back to unselected
self.clear = function() {
	// set dd btn default text
	$('.room-selector__dd-btn .h5').text( default_text );

	// remove indicator class
	$('.rooms__room--active').removeClass('rooms__room--active');

	// default selected value;
	active_value = null;
}


// api set value
self.set = function(value) {
	var room_el = $('.rooms__room[data-value="' + value + '"]');
	room_el.click();
}


// get current value
self.get = function() {
	return active_value
}


// method that allows callback function to be defined when value changes
self.on_change = function(cb) {
	listener = true;
	listener_cb = cb;
}


// method to stop reporting of value change
self.stop_listen = function() {
	listener = false;
	listener_cb = null;
}


// remove button listeners
self.kill = function() {
	$('.room-selector__group').off();
	$('.rooms__room').off();
}



/**********************************************
 Module Export
**********************************************/
module.exports = self;